import { memo, useEffect, useState } from "react";
import { getDHM } from "@/utils/dhmCalculation";
import { LuClock9 } from "react-icons/lu";

const Counter = ({until}) => {
  const currentDate = new Date();
  const futureDate = new Date();
  const safeUntil = until && !isNaN(until) ? until : 0;
  futureDate.setDate(currentDate.getDate() + parseInt(safeUntil / (60 * 60 * 24), 10))
  futureDate.setHours(currentDate.getHours() + parseInt(safeUntil / (60 * 60), 10) % 24)
  futureDate.setMinutes(currentDate.getMinutes() + parseInt(safeUntil / 60, 10) % 60)
  futureDate.setSeconds(currentDate.getSeconds() + safeUntil % 60)
  const [getCurrentTime, setCurrentTime] = useState(getDHM(futureDate));

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentTime(getDHM(futureDate))
    }, 60000);
    return () => clearInterval(intervalId);
  }, [until]);

  return (
    <div className="timerBg pl10 pr10 pb0 pt0 align-items-center d-flex"  style={{ width:'auto'}}>
      <LuClock9  color="#254A72"/>

      <div className="cols pl5 pt2 pb2">
        <p className="timerFont text-center mb0 ">{getCurrentTime?.days  + 'd' || 0 + 'd '}</p>
        {/* <p className="text-thm bold text-center mb0">Days</p> */}
      </div>
      <div className="cols pt2 pb2">
        <p className="timerFont text-center ml5 mb0 ">{getCurrentTime?.hours   + 'h'|| 0 + 'h '}</p>
      </div>
      
      <div className="cols pt2 pb2">
        <p className=" timerFont text-center ml5 mb0 ">{getCurrentTime?.minutes  + 'm' || 0  + 'm'}</p>
      </div>
    </div>
  );
};

export default memo(Counter);
